import '../../style/mobile/financial/MFinancial.scss';


let data = [
  {
    id: 1,
    orderNumber: 123473421,
    date: "1400/09/11",
    situation: true,
    transactionNumber: 12555638,
    sumPrice: 200000,
    items: [
      {
        id: 1,
        name: "آزمون علوم آزمایشگاهی پیشرفته پایه دوازدهم",
        price: 100000,
      },
      {
        id: 2,
        name: "آزمون علوم آزمایشگاهی پیشرفته پایه دوازدهم",
        price: 100000,
      },
    ],
  },
  {
    id: 2,
    orderNumber: 123473421,
    date: "1400/08/08",
    situation: false,
    transactionNumber: 12555638,
    sumPrice: 350000,
    items: [
      {
        id: 1,
        name: "آزمون علوم آزمایشگاهی پیشرفته پایه دوازدهم",
        price: 100000,
      },
      {
        id: 2,
        name: "آزمون علوم آزمایشگاهی پیشرفته پایه دوازدهم",
        price: 120000,
      },
      {
        id: 3,
        name: "آزمون علوم آزمایشگاهی پیشرفته پایه دوازدهم",
        price: 130000,
      },
    ],
  },
];

const MFinancial = () => {
  return (
    <div className="MFinancial">
      <div className="MFinancial-title">لیست تراکنش‌ها</div>
      <div className="MFinancial-body">
        {data.map((item) => (
          <div className="MFinancial-body-item" key={item.id}>
            <div className="MFinancial-body-item-title-box">
              <div className="MFinancial-body-item-title-box-order-number">
                شماره سفارش: <span>{item.orderNumber}</span>
              </div>
              <div className="MFinancial-body-item-title-box-date">
                تاریخ: <span>{item.date}</span>
              </div>
            </div>
            <div className="MFinancial-body-item-body">
              <div className="MFinancial-body-item-body-main">
                {item.items.map((item, index) => (
                  <div
                    className="MFinancial-body-item-body-main-item"
                    key={index}
                  >
                    <div className="MFinancial-body-item-body-main-item-number">
                      {index + 1}
                    </div>
                    <div className="MFinancial-body-item-body-main-item-name">
                      {item.name}
                    </div>
                    <div className="MFinancial-body-item-body-main-item-price">
                      {item.price} تومان
                    </div>
                  </div>
                ))}
              </div>
              <div className="MFinancial-body-item-body-footer">
                <div className="MFinancial-body-item-body-footer-see-factor-btn">
                  مشاهده فاکتور
                </div>
                <div
                  style={
                    item.situation
                      ? { backgroundColor: "#EAFFDD", color: "#1F5200" }
                      : { backgroundColor: "#F8E8E8", color: "#520000" }
                  }
                  className="MFinancial-body-item-body-footer-situation"
                >
                  {item.situation && "پرداخت موفق"}
                  {!item.situation && "عودت مبلغ"}
                </div>
                <div className="MFinancial-body-item-body-footer-sum">
                  جمع فاکتور:{" "}
                  <span className="MFinancial-body-item-body-footer-sum-cost">
                    {item.sumPrice}
                  </span>{" "}
                  تومان
                </div>
                <div className="MFinancial-body-item-body-footer-transactionNumber">
                  شماره تراکنش: {item.transactionNumber}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MFinancial;